import { Typeahead } from 'uiv'
import search from '@/sui/tools/search'

export default function () {
  Typeahead.methods.prepareItems = function (data, disableFilters = false) {
    if (disableFilters) {
      this.items = data.slice(0, this.limit)
      return
    }
    this.activeIndex = this.preselect ? 0 : -1
    const restrictToMatch = this.preparedOnce === true
    this.items = search.sortedMatches(
      this.inputEl.value, data, this.limit, this.itemKey, this.ignoreCase,
      restrictToMatch, this.matchStart
    )
    this.preparedOnce = true
  }
}
